import { type ReactNode } from 'react'
import styles from './SectionHeading.module.scss'

interface SectionHeadingProps {
  action?: ReactNode
  subtitle?: string
  title: string
}

export const SectionHeading = ({ action, subtitle, title }: SectionHeadingProps) => (
  <div className={styles.heading}>
    <div>
      <h2 className={styles.title}>{title}</h2>
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
    </div>
    {action ? <div className={styles.action}>{action}</div> : null}
  </div>
)
